<template>
  <section aria-labelledby="history-title">
    <Card class="overflow-x-auto overflow-hidden">
      <CardHeader>
        <CardTitle>History</CardTitle>
      </CardHeader>
      <DataTable :columns="columns" :rows="history" />
    </Card>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import DataTable from '../shared/DataTable/DeprecatedDataTable.vue';
import { Card, CardHeader, CardTitle } from '@/components/ui/card';
import { formatCurrencyToHuman, formatStandardDate } from '../../utilities/format.ts';

defineProps<{
  history: Record<string, unknown>[];
}>();

const columns = computed(() => [
  { label: 'Start Date', key: 'start_date', sortable: false, formatter: formatStandardDate },
  { label: 'End Date', key: 'end_date', sortable: false, formatter: formatStandardDate },
  { label: 'Indeed', key: 'indeed_spend', sortable: false, formatter: formatCurrencyToHuman },
  { label: 'ZipRecruiter', key: 'zip_spend', sortable: false, formatter: formatCurrencyToHuman },
  { label: 'Monster', key: 'monster_spend', sortable: false, formatter: formatCurrencyToHuman },
  { label: 'Meta', key: 'meta_spend', sortable: false, formatter: formatCurrencyToHuman },
  { label: 'Total Spend', key: 'total_spend', sortable: false, formatter: formatCurrencyToHuman },
  { label: '$ per Candidate', key: 'cost_per_candidate', sortable: false, formatter: formatCurrencyToHuman },
  { label: '# of Candidates', key: 'number_of_candidates', sortable: false },
  {
    label: '$ per Candidate (Indeed)',
    key: 'cost_per_candidate_indeed',
    sortable: false,
    formatter: formatCurrencyToHuman,
  },
  { label: '# of Candidates (Indeed)', key: 'number_of_candidates_indeed', sortable: false },
  {
    label: '$ per Candidate (Zip)',
    key: 'cost_per_candidate_zip',
    sortable: false,
    formatter: formatCurrencyToHuman,
  },
  { label: '# of Candidates (Zip)', key: 'number_of_candidates_zip', sortable: false },
  {
    label: '$ per Candidate (Monster)',
    key: 'cost_per_candidate_monster',
    sortable: false,
    formatter: formatCurrencyToHuman,
  },
  { label: '# of Candidates (Monster)', key: 'number_of_candidates_monster', sortable: false },
  {
    label: '$ per Candidate (Meta)',
    key: 'cost_per_candidate_meta',
    sortable: false,
    formatter: formatCurrencyToHuman,
  },
  { label: '# of Candidates (Meta)', key: 'number_of_candidates_meta', sortable: false },
]);
</script>
